import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { CATEGORIES, CATEGORY_COLORS } from "../data/mockData";
import { formatCurrency, formatDate, getFilteredTransactions, exportToCSV, exportToJSON } from "../utils/helpers";
import { FaSearch, FaEdit, FaTrash, FaPlus, FaDownload, FaChartPie, FaWallet } from "react-icons/fa";
import TransactionModal from "../components/TransactionModal";


export default function Transactions() {
  const { state, dispatch } = useApp();
  const { transactions, theme, role, filters } = state;
  const dark = theme === "dark";
  const isAdmin = role === "admin";

  const [modal, setModal] = useState(null); // null | "add" | transaction object
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [page, setPage] = useState(1);
  const PER_PAGE = 12;

  const filtered = getFilteredTransactions(transactions, 
    filters);
  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paginated = filtered.slice((page - 1) * PER_PAGE, page
   * PER_PAGE);

  const f = (key, val) => { dispatch({ type:
     "SET_FILTER", payload: { [key]: val } }); setPage(1); };

  const inputStyle = {
    padding: "9px 12px", borderRadius: 8, fontSize: 13, outline: 
    "none",
    border: `1px solid ${dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.12)"}`,
    background: dark ? "rgba(255,255,255,0.05)" : "#fff",
    color: dark ? "#f1f5f9" : "#0f172a",
  };

  const selectStyle = { ...inputStyle, cursor: "pointer" };

  return (
    <div style={{ padding: 24, maxWidth: 1400 }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: 
        "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: "0 0 2px", color: dark ? "#f1f5f9" : "#0f172a", fontSize: 20, fontWeight: 700 }}>Transactions</h2>
          <p style={{ margin: 0, color: dark ? "#475569" : "#94a3b8", fontSize: 13 }}>{filtered.length} of {transactions.length} transactions</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => exportToCSV(filtered)} 
          style={{ ...inputStyle, cursor: "pointer", border: `1px solid ${dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.12)"}` }}>⬇ CSV</button>
          <button onClick={() => exportToJSON(filtered)} style={{ ...inputStyle, cursor: "pointer" }}>⬇ JSON</button>
          {isAdmin && (
            <button onClick={() => setModal("add")} 
            style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: "linear-gradient(135deg, #6366f1, #4f46e5)", color: "#fff", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
              + Add Transaction
            </button>
          )}
        </div>
      </div>

      {/* Filters */}
      <div style={{
        background: dark ? "rgba(255,255,255,0.03)" : "#fff",
        border: `1px solid ${dark ? "rgba(255,255,255,0.06)" : 
          "rgba(0,0,0,0.08)"}`,
        borderRadius: 12, padding: "16px 20px", marginBottom: 20,
        display: "flex", flexWrap: "wrap", gap: 12,
      }}>
       <div style={{ position: "relative", flex: "1 1 200px", minWidth: 200 }}>
  
  <i
    className="fa-solid fa-magnifying-glass"
    style={{
      position: "absolute",
      left: 10,
      top: "50%",
      transform: "translateY(-50%)",
      color: dark ? "#94a3b8" : "#64748b",
      fontSize: 13
    }}
  ></i>

  <input
    placeholder="Search transactions..."
    value={filters.search}
    onChange={(e) => f("search", e.target.value)}
    style={{
      ...inputStyle,
      paddingLeft: 30,
      width: "100%"
    }}
  />
</div>

<select value={filters.category} onChange={(e) => f("category", e.target.value)} style={selectStyle}>
  <option style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }} value="all">
    All Categories
  </option>

  {CATEGORIES.map((c) => (
    <option
      key={c}
      value={c}
      style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}
    >
      {c}
    </option>
  ))}
</select>

        <select value={filters.type} onChange={(e) => f("type", e.target.value)} style={selectStyle}>
          <option value="all" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>All Types</option>
          <option value="income" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>Income</option>
          <option value="expense" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>Expense</option>
        </select>


        
        <select value={`${filters.sortBy}-${filters.sortOrder}`}
          onChange={(e) => { const [sb, so] = e.target.value.split("-"); f("sortBy", sb); dispatch({ type: "SET_FILTER", payload: { sortOrder: so } }); }}
          style={selectStyle}>
          <option value="date-desc" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>Date ↓</option>
          <option value="date-asc" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>Date ↑</option>
          <option value="amount-desc" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>Amount ↓</option>
          <option value="amount-asc" style={{ backgroundColor: dark ? "#0f172a" : "#fff", color: dark ? "#fff" : "#000" }}>Amount ↑</option>
        </select>

        
        {(filters.search || filters.category !== "all" || filters.type !== "all") && (
          <button onClick={() => dispatch({ type: "SET_FILTER", payload: { search: "", category: "all", type: "all" } })}
            style={{ ...inputStyle, cursor: 
              "pointer", color: "#f43f5e", borderColor: "rgba(244,63,94,0.3)" }}>Clear ×</button>
        )}
      </div>

      {/* Table */}
      <div style={{
        background: dark ?
         "rgba(255,255,255,0.03)" : "#fff",
        border: `1px solid ${dark ? "rgba(255,255,255,0.06)"
           : "rgba(0,0,0,0.08)"}`,
        borderRadius: 12, overflow: "hidden",
        boxShadow: dark ? "0 4px 24px rgba(0,0,0,0.2)" : 
        "0 4px 20px rgba(0,0,0,0.06)",
      }}>
        {paginated.length === 0 ? (
          <div style={{ padding: "60px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📭</div>
            <p style={{ color: dark ? "#475569" : "#94a3b8",
               fontSize: 16, fontWeight: 500 }}>No transactions found</p>
            <p style={{ color: dark ? "#334155" : "#cbd5e1",
               fontSize: 13 }}>Try adjusting your filters</p>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)"}` }}>
                  {["Date", "Description", "Category", "Type", "Amount", ...(isAdmin ? ["Actions"] : [])].map((h) => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: h === "Amount" || h === "Actions" ? "right" : "left", color: dark ? "#475569" : "#94a3b8", fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginated.map((tx, i) => (
                  <tr key={tx.id} style={{
                    borderBottom: `1px solid ${dark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.05)"}`,
                    transition: "background 0.15s",
                  }}
                    onMouseEnter={(e) => e.currentTarget.style.background = dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)"}
                    onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                  >
                    <td style={{ padding: "14px 16px", color: dark ? "#64748b" : "#94a3b8", fontSize: 13, whiteSpace: "nowrap" }}>{formatDate(tx.date)}</td>
                    <td style={{ padding: "14px 16px", color: dark ? "#e2e8f0" : "#0f172a", fontSize: 14, fontWeight: 500 }}>{tx.description}</td>
                    <td style={{ padding: "14px 16px" }}>
                      <span style={{
                        padding: "4px 10px", borderRadius: 20, fontSize: 12, fontWeight: 500,
                        background: `${CATEGORY_COLORS[tx.category]}20`,
                        color: CATEGORY_COLORS[tx.category] || "#6b7280",
                        border: `1px solid ${CATEGORY_COLORS[tx.category]}40`,
                      }}>{tx.category}</span>
                    </td>
                    <td style={{ padding: "14px 16px" }}>
                      <span style={{
                        padding: "4px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600,
                        background: tx.type === "income" ? "rgba(16,185,129,0.12)" : "rgba(244,63,94,0.12)",
                        color: tx.type === "income" ? "#10b981" : "#f43f5e",
                      }}>{tx.type === "income" ? "↑ Income" : "↓ Expense"}</span>
                    </td>
                    <td style={{ padding: "14px 16px", textAlign: "right", color: tx.type === "income" ? "#10b981" : "#f43f5e", fontSize: 15, fontWeight: 700, whiteSpace: "nowrap" }}>
                      {tx.type === "income" ? "+" : "-"}{formatCurrency(tx.amount)}
                    </td>
                    {isAdmin && (
                      <td style={{ padding: "14px 16px", textAlign: "right" }}>
                        <button onClick={() => setModal(tx)} style={{ background: "none", border: "none", cursor: "pointer", color: dark ? "#475569" : "#94a3b8", fontSize: 16, marginRight: 8, padding: "4px 6px", borderRadius: 6, transition: "all 0.15s" }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(99,102,241,0.15)"; e.currentTarget.style.color = "#a5b4fc"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = dark ? "#475569" : "#94a3b8"; }}><i className="fa-solid fa-pen"></i>
</button>
                        <button onClick={() => setDeleteConfirm(tx.id)} style={{ background: "none", border: "none", cursor: "pointer", color: dark ? "#475569" : "#94a3b8", fontSize: 16, padding: "4px 6px", borderRadius: 6, transition: "all 0.15s" }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(244,63,94,0.15)"; e.currentTarget.style.color = "#f87171"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = dark ? "#475569" : "#94a3b8"; }}><i className="fa-solid fa-trash"></i></button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={{ padding: "16px 20px", borderTop: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)"}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ color: dark ? "#475569" : "#94a3b8", fontSize: 13 }}>Page {page} of {totalPages}</span>
            <div style={{ display: "flex", gap: 6 }}>
              {[...Array(Math.min(totalPages, 7))].map((_, i) => {
                const p = i + 1;
                return (
                  <button key={p} onClick={() => setPage(p)} style={{
                    width: 32, height: 32, borderRadius: 6, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 500,
                    background: page === p ? "#6366f1" : "transparent",
                    color: page === p ? "#fff" : dark ? "#475569" : "#94a3b8",
                    transition: "all 0.15s",
                  }}>{p}</button>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Delete Confirm */}
      {deleteConfirm && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: dark ? "#0d1324" : "#fff", borderRadius: 16, padding: 28, maxWidth: 360, width: "90%", textAlign: "center", border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.1)"}` }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h3 style={{ margin: "0 0 8px", color: dark ? "#f1f5f9" : "#0f172a" }}>Delete Transaction?</h3>
            <p style={{ color: dark ? "#475569" : "#94a3b8", fontSize: 14, margin: "0 0 20px" }}>This cannot be undone.</p>
            <div style={{ display: "flex", gap: 12 }}>
              <button onClick={() => setDeleteConfirm(null)} style={{ flex: 1, padding: "10px", borderRadius: 8, border: `1px solid ${dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.15)"}`, background: "transparent", color: dark ? "#94a3b8" : "#64748b", cursor: "pointer" }}>Cancel</button>
              <button onClick={() => { dispatch({ type: "DELETE_TRANSACTION", payload: deleteConfirm }); setDeleteConfirm(null); }} style={{ flex: 1, padding: "10px", borderRadius: 8, border: "none", background: "linear-gradient(135deg, #f43f5e, #e11d48)", color: "#fff", cursor: "pointer", fontWeight: 600 }}>Delete</button>
            </div>
          </div>
        </div>
      )}

      {modal && <TransactionModal transaction={modal === "add" ? null : modal} onClose={() => setModal(null)} />}
    </div>
  );
}
